const defaultRender = (value) => (value ? value : '--');

const dueFilter = [
    { text: "Yes", value: true },
    { text: "No", value: false }
];

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
    },
    {
        title: 'Submit',
        dataIndex: 'submit',
        render: defaultRender,
    },
    {
        title: 'Tag',
        dataIndex: 'tag',
        render: defaultRender,
        onFilter: (value, record) => {
            return record?.task_tag === value;
        },
        width: 200
    },
    {
        title: 'Assigned To',
        dataIndex: 'employee_name',
        render: defaultRender,
    },
    {
        title: 'Received Date',
        dataIndex: 'startDate',
        render: defaultRender,
    },
    {
        title: 'Due',
        dataIndex: 'due',
        render: defaultRender,
        filters: dueFilter,
        onFilter: (value, record) => record?.is_due === value,
    },
    {
        title: 'Due Date',
        dataIndex: 'dueDate',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title:'Action',
        dataIndex: 'action',
        fixed: 'right',
    },
];

export default columns;